/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core';

// import icons
import LoadingIcon from '../../assets/images/loading.svg';

const useStyles = makeStyles(
  () => ({
    root: {},
    dialogOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: '100vw',
      overflow: 'auto',
      zIndex: '999',
      background: 'rgba(255, 255, 255, 0.9)',
    },
    dialogContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      display: 'flex',
      height: '100vh',
    },
    loadingIndicator: {
      '& img': {
        width: '42px',
        height: '42px',
        display: 'block',
        margin: '0 auto',
        animation: 'spin 1s infinite linear',
      },
    },
  }),
  'loading-component',
);
const Loading = () => {
  const classes = useStyles();
  return (
    <div className={classes.dialogOverlay}>
      <div className={classes.dialogContainer}>
        <div className={classes.loadingIndicator}>
          <img src={LoadingIcon} alt="loading" />
        </div>
      </div>
    </div>
  );
};
export default Loading;